import * as types from '../constants';

export const setHotelList = hotelList => ({
  type: types.SET_HOTEL_LIST,
  payload: hotelList
});
